import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Graph } from "../../../../../assets/AccountingModule/Group 206.svg";
import { ReactComponent as FileImport } from "../../../../../assets/AccountingModule/uil_file_import.svg";
import SubHeader from "../../../../../components/SubHeader";
import TransactionChart from "../../../../../components/TransactionChart/TransactionChart.jsx";
import color from "../../../../../constants/color";
import BankList from "./BankList";
import style from "./style";

function BankHomePage({
  data,
  page,
  setPage,
  total,
  handleFilter,
  transactionStats,
  cashAccount,
}) {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };
  const theme = useTheme();
  return (
    <>
      <Box
        px="15px"
        pt="20px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5" sx={style.heading}>
          Banking Overview
        </Typography>

        <Box
          display="flex"
          justifyContent={{ xs: "start", md: "end" }}
          alignItems={{ xs: "start", md: "end" }}
        >
          <Button
            variant="contained"
            color="success"
            sx={style.checkinBtn}
            onClick={() => handleNavigate("/dashboard/addBank")}
          >
            + Add Bank
          </Button>
        </Box>
      </Box>
      <Grid container sx={style.gridContainer}>
        <Grid item xs={12} lg={6.7} sx={style.gridbox}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box>
              <Typography sx={style.reportHeading}>
                Deposits and Withdrawals
              </Typography>
            </Box>

            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box sx={{ display: "flex", alignItems: "" }}>
                <Box sx={style.grayDot}></Box>
                <Typography sx={{ ...style.purchase, mt: "1px" }}>
                  Deposits
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Box sx={style.greenDot}></Box>
                <Typography sx={{ ...style.purchase, mt: "1px" }}>
                  Withdrawals
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={style.graph}>
            <Graph />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              px: "4rem",
            }}
          >
            <Typography sx={{ color: "#878787" }}>Mar</Typography>
            <Typography sx={{ color: "#878787" }}>Apr</Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          lg={5.1}
          sx={{
            ...style.gridboxAttendance,
            backgroundColor: theme.palette.secondary.main,
          }}
        >
          <Box>
            <Typography sx={{ ...style.cardTitle, color: color.card }}>
              Transaction of the day
            </Typography>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              mt="15px"
            >
              <TransactionChart value={420} text={"Transaction"} />
              <Box display="flex" flexDirection="column" ml="20px" width="50%">
                {" "}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    mb: "5px ",
                  }}
                >
                  <Typography sx={{ color: "#fff" }}>
                    {"Total Transactions "}
                  </Typography>
                  <Typography sx={{ color: "#fff" }}>
                    {transactionStats.total}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    mb: "5px ",
                  }}
                >
                  <Typography sx={{ color: "#fff" }}>{"Deposits"}</Typography>
                  <Typography sx={{ color: "#fff" }}>
                    {transactionStats.deposits}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    mb: "5px ",
                  }}
                >
                  <Typography sx={{ color: "#fff" }}>
                    {"Withdrawals"}
                  </Typography>
                  <Typography sx={{ color: "#fff" }}>
                    {transactionStats.withdrawals}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          title={"All Account"}
          // isShow={false}
          // search
          sortBy
          onchange={(e) => handleFilter(e)}
          handleSort={(e) => handleFilter("", e)}
        />

        <BankList data={data} setPage={setPage} page={page} total={total} cashAccount={cashAccount} />
      </Box>
    </>
  );
}

export default BankHomePage;
